(function(){

  function pad(value){
    return String(value).padStart(2,'0');
  }


  function initCountdown(root){

    const endTimeValue=
      root.dataset.endTime;


    if(!endTimeValue){
      return;
    }


    const endTime=
      new Date(endTimeValue).getTime();


    if(!Number.isFinite(endTime)){
      console.warn(
        'Invalid product sale countdown end time:',
        endTimeValue
      );

      return;
    }


    const daysEl=
      root.querySelector('[data-days]');

    const hoursEl=
      root.querySelector('[data-hours]');

    const minutesEl=
      root.querySelector('[data-minutes]');

    const secondsEl=
      root.querySelector('[data-seconds]');


    if(
      !daysEl ||
      !hoursEl ||
      !minutesEl ||
      !secondsEl
    ){
      return;
    }


    function update(){

      const now=
        Date.now();


      let distance=
        endTime-now;


      /*
       * SALE ENDED
       */
      if(distance<=0){

        daysEl.textContent='00';
        hoursEl.textContent='00';
        minutesEl.textContent='00';
        secondsEl.textContent='00';


        /*
         * 活动结束后隐藏整个模块
         */
        root.style.display='none';


        return false;
      }


      /*
       * DAYS
       */
      const days=
        Math.floor(
          distance /
          (1000*60*60*24)
        );


      distance%=
        1000*60*60*24;


      /*
       * HOURS
       */
      const hours=
        Math.floor(
          distance /
          (1000*60*60)
        );


      distance%=
        1000*60*60;


      /*
       * MINUTES
       */
      const minutes=
        Math.floor(
          distance /
          (1000*60)
        );


      distance%=
        1000*60;


      /*
       * SECONDS
       */
      const seconds=
        Math.floor(
          distance/1000
        );


      /*
       * UPDATE UI
       */
      daysEl.textContent=
        pad(days);

      hoursEl.textContent=
        pad(hours);

      minutesEl.textContent=
        pad(minutes);

      secondsEl.textContent=
        pad(seconds);


      return true;
    }


    /*
     * 第一时间执行一次
     * 避免页面先显示 00:00:00:00
     */
    const active=
      update();


    if(!active){
      return;
    }


    /*
     * 每秒更新
     */
    const timer=
      setInterval(()=>{

        const stillActive=
          update();


        if(!stillActive){
          clearInterval(timer);
        }

      },1000);

  }


  /*
   * 支持一个页面存在多个 countdown
   */
  function initAllCountdowns(){

    document
      .querySelectorAll(
        '[data-sale-countdown]'
      )
      .forEach(root=>{

        if(
          root.dataset.countdownInitialized==='true'
        ){
          return;
        }


        root.dataset.countdownInitialized=
          'true';


        initCountdown(root);

      });

  }


  if(document.readyState==='loading'){

    document.addEventListener(
      'DOMContentLoaded',
      initAllCountdowns
    );

  }else{

    initAllCountdowns();

  }


})();